import React from 'react'
import { NoticeBar } from 'common/styleguide/NoticeBar'
import moment from 'moment'
import { FormattedMessage as T } from 'react-intl'

const IE_NUDGE_BAR_PREF = 'show_ie_nudge_bar'

export class IeNudgeBar extends React.PureComponent {
  clearIENudge = () => {
    const { setPreference } = this.props
    setPreference(IE_NUDGE_BAR_PREF, false)
  }

  render () {
    const { currentUser } = this.props
    const isIE = !!window.MSInputMethodContext && !!document.documentMode
    const showIENudge = isIE && moment().diff(moment(currentUser.createdAt), 'days') > 1 &&
      currentUser.preferences.get(IE_NUDGE_BAR_PREF, true)

    if (!showIENudge) {
      return null
    }

    return (
      <NoticeBar onRequestClose={this.clearIENudge}>
        <T
          id='ieNudgeBar.message'
          defaultMessage="Hey, we noticed you're using Internet Explorer. To take full
          advantage of our newest features and improvements, we suggest upgrading
          to a modern browser like Chrome or Firefox. You can learn more by
          visiting our {link}"
          values={{
            link: (<a href='/recommended_browsers'>
              <T id='ieNudgeBar.linkText' defaultMessage='browser upgrade page' />
            </a>)
          }} />
      </NoticeBar>
    )
  }
}
